module.exports = __webpack_public_path__ + "ab803f0bb365a1e96478f15ad4511b80.pdf";